import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private messageService = inject(MessageService);

  /**
   * Shows an error toast with support for multiple messages as a bulleted list
   */
  showError(messages: string | string[], summary?: string): void {
    const detail = this.formatMessages(messages);
    this.messageService.add({
      severity: 'error',
      summary: summary,
      detail: detail,
    });
  }

  /**
   * Shows a success toast
   */
  showSuccess(message: string, summary?: string): void {
    this.messageService.add({
      severity: 'success',
      summary: summary,
      detail: message,
    });
  }

  /**
   * Shows a warning toast
   */
  showWarning(message: string, summary?: string): void {
    this.messageService.add({
      severity: 'warn',
      summary: summary,
      detail: message,
    });
  }

  /**
   * Shows an info toast
   */
  showInfo(message: string, summary?: string): void {
    this.messageService.add({
      severity: 'info',
      summary: summary,
      detail: message,
    });
  }

  /**
   * Formats messages as a bulleted list using bullet characters
   */
  private formatMessages(messages: string | string[]): string {
    if (typeof messages === 'string') {
      return messages;
    }

    if (messages.length === 0) {
      return 'An unknown error occurred';
    }

    if (messages.length === 1) {
      return messages[0];
    }

    return messages.map((msg) => `• ${msg}`).join('\n');
  }
}
